module.exports = __webpack_public_path__ + "static/herobg-05-min-ff259f5e6666dba23aba2eaa04b68b49.jpg";